import { createVuetify } from 'vuetify'
import { VBtn } from 'vuetify/components/VBtn'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n'
import { useI18n } from 'vue-i18n'
import { i18n } from '@KTXC/l10n/runtime'
import defaults from './defaults'
import { icons } from './icons'
import { themes } from './theme'

// Styles
import 'vuetify/styles'

export default createVuetify({
  components,
  directives,
  aliases: {
    IconBtn: VBtn,
  },
  defaults,
  icons,
  locale: {
    adapter: createVueI18nAdapter({ i18n, useI18n }),
  },
  theme: {
    // Follow the browser/OS color scheme by default; matters especially for
    // the public (unauthenticated) app, where no theme store ever runs.
    defaultTheme: 'system',
    themes,
  },
})
